import { createIcon } from "@chakra-ui/react";

export const Support = createIcon({
  displayName: "Support",
  viewBox: "0 0 24 24",
  path: [
    <mask
      id="dh6oh00eza"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="25"
    >
      <path fill="#D9D9D9" d="M0 .019h24v24H0z" />
    </mask>,
    <g mask="url(#dh6oh00eza)">
      <path
        d="M7.259 7.157c-1.123-1.18-1.123-3.094 0-4.273a2.776 2.776 0 0 1 4.063 0l.676.712.676-.712a2.776 2.776 0 0 1 4.063 0c1.123 1.18 1.123 3.094 0 4.273l-3.88 4.082a1.176 1.176 0 0 1-1.718 0l-3.88-4.082zm.897 8.51c-.301 0-.595.09-.847.264L4.257 18.04a.9.9 0 0 1-.507.158H1.917c-.508 0-.917-.423-.917-.95 0-.525.409-.949.917-.949H3.47l2.818-1.946a3.272 3.272 0 0 1 1.867-.586h5.98c1.349 0 2.445 1.136 2.445 2.532v.08l2.478-1.583a2.504 2.504 0 0 1 1.356-.396h.282C21.97 14.4 23 15.47 23 16.786c0 .807-.397 1.563-1.05 2.002l-3.65 2.448a4.462 4.462 0 0 1-2.49.764l-13.893-.004c-.508 0-.917-.423-.917-.95 0-.526.409-.949.917-.949h13.888c.531 0 1.05-.158 1.494-.459l3.65-2.449a.49.49 0 0 0 .214-.407.478.478 0 0 0-.47-.487h-.282a.737.737 0 0 0-.394.115l-3.57 2.275a.903.903 0 0 1-.481.142h-5.194c-.508 0-.916-.423-.916-.95 0-.525.408-.949.916-.949H14.133a.624.624 0 0 0 .61-.633.624.624 0 0 0-.61-.633h-5.98l.003.004z"
        fill="currentColor"
      />
    </g>
  ],
  defaultProps: {
    "aria-label": "Heart above hand emoji"
  }
});

export default Support;
